import {getRankersUserAgent} from "../constants/rankers_user_agent";

export const XHR_ACCEPT_HEADERS = 'text/javascript, text/html, application/xml, text/xml, */*';
export const XHR_REQUESTED_WITH_HEADERS = 'XMLHttpRequest';
export const GET_HTTP_METHOD = 'GET';
export const HEAD_HTTP_METHOD = 'HEAD';

export const POST_HTTP_METHOD = 'POST';

export function getRequest(url, options={}) {
    options['method'] = options['method'] || GET_HTTP_METHOD;
    options['headers'] = options['headers'] || {};

    // When there are params we need to include them in the request.
    // For GET/HEAD requests they are appended to the URL.
    // Otherwise they are included in the request body.
    const formElement = options['formElement'] || null;
    let params = formElement ? new FormData(formElement) : new FormData();
    const hasParams = (params) ? params.entries().next().value !== undefined : false;
    if (hasParams) {
        if (options['method'] === GET_HTTP_METHOD || options['method'] === HEAD_HTTP_METHOD) {
            for (const pair of params) {
                url.searchParams.append(pair[0], pair[1])
            }
        } else {
            options['body'] = params;
        }
    }

    // Include cookies in the request to approved domains (based on the cookie's `domain` value).
    // The server also needs to respond to the preflight OPTIONS request with the `Access-Control-Allow-Credentials` header set to `true`.
    // See `CrossDomainAccess#set_cross_domain_access` in the Rails app where this is set.
    options['credentials'] ??= 'include';

    let request = new Request(url, options);

    // Note that with CORS the server must allow these headers to be set.
    // See the Rails controller module `CrossDomainAccess#set_cross_domain_access`.
    request.headers.set('Accept', XHR_ACCEPT_HEADERS); // Important! Ensures that the Rails `format.js` response block is run.
    request.headers.set('X-Requested-With', XHR_REQUESTED_WITH_HEADERS); // Important! Ensures that the Rails method `request.xhr?` returns true.

    // Set the Rankers user agent header. This is used to specify the client that is making the request.
    // Setting the header (rather than relying on the client's user agent) is necessary because the user agent is not always correctly set when making JS requests from a webview.
    // This is a failsafe so that the server can still identify the client even if the user agent is not set correctly.
    request.headers.set('X-Rankers-User-Agent', getRankersUserAgent());

    // Override the headers set above with any headers passed in the options.
    Object.entries(options['headers']).forEach(([key, value]) => {
        request.headers.set(key, value);
    });

    return request;
}
